module.exports = __webpack_public_path__ + "static/00015.ef75442c.jpg";